var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 128,
    viewBox: "0 0 78 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 128,
    rx: 5,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1858_9862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5008 35.425C24.5668 35.425 12.4258 47.566 12.4258 62.5C12.4258 77.434 24.5668 89.575 39.5008 89.575C54.4348 89.575 66.5758 77.434 66.5758 62.5C66.5758 47.566 54.4348 35.425 39.5008 35.425ZM39.5008 48.592C44.0608 48.592 47.7658 52.867 47.7658 58.168C47.7658 63.469 44.0608 67.801 39.5008 67.801C34.9408 67.801 31.2358 63.526 31.2358 58.225C31.2358 52.924 34.9408 48.592 39.5008 48.592ZM39.5008 84.616C33.0598 84.616 27.2458 81.823 23.1988 77.434C23.7118 74.071 25.8778 71.164 29.0128 69.739L31.5778 68.542C33.6868 70.537 36.4798 71.734 39.5008 71.734C42.5218 71.734 45.2578 70.537 47.4238 68.542L49.9888 69.739C53.1238 71.164 55.2898 74.071 55.8028 77.434C51.7558 81.88 45.9418 84.616 39.5008 84.616Z",
    fill: "#C2E4FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1858_9862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 58,
    fill: "white",
    transform: "translate(11 34)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPic);
export default __webpack_public_path__ + "static/media/empty_pic.551b41177e421e48a2f8bc2fad41efcb.svg";
export { ForwardRef as ReactComponent };